export default __webpack_public_path__ + "static/media/K420_CoC.9dcb6a00.pdf";